import { ColumnHelper, ColumnMeta } from '@tanstack/react-table';
import { twJoin } from 'tailwind-merge';
import { OrderSide } from '../../types/generated';
import { MarketCell } from './MarketCell';

interface MarketData {
  baseTokenName: string;
  displayTicker: string;
  side: OrderSide;
  ticker: string;
  maxLeverage?: number;
}

export const getMarketColumn = <T extends MarketData>(
  columnHelper: ColumnHelper<T>,
  options?: {
    displaySide?: boolean;
    enableSorting?: boolean;
    displayLeverage?: boolean;
    meta?: ColumnMeta<T, Omit<T, 'meta'>>;
  }
) => {
  return columnHelper.accessor(
    ({ baseTokenName, displayTicker, side, ticker, maxLeverage }) => ({
      baseTokenName,
      displayTicker,
      side,
      ticker,
      maxLeverage,
    }),
    {
      id: 'baseTokenName_market_side',
      header: 'Market',
      meta: {
        cellContainerClassName: 'w-0 min-w-[130px]',
        ...options?.meta,
      },
      enableSorting: options?.enableSorting,
      cell: (info) => {
        const { displayTicker, side, ticker, maxLeverage } = info.getValue();
        const isBuy = side === OrderSide.BUY;

        return (
          <MarketCell
            ticker={ticker}
            subtitle={
              options?.displaySide ? (
                <span
                  className={twJoin(
                    'text-3xs font-normal',
                    isBuy ? 'text-contentGreen' : 'text-contentRed'
                  )}
                >
                  {isBuy ? 'Long' : 'Short'}
                </span>
              ) : undefined
            }
          >
            {displayTicker}
            {options?.displayLeverage ? (
              <>
                {' '}
                <span
                  className={twJoin('text-3xs', isBuy ? 'text-contentGreen' : 'text-contentRed')}
                >
                  {maxLeverage}x
                </span>
              </>
            ) : null}
          </MarketCell>
        );
      },
    }
  );
};
